import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EsignStoreModule } from './esign-store/esign-store.module';
import { TicketStoreModule } from 'src/app/root-store/ticket-store/ticket-store.module';
import { TicketEmailSettingsStoreModule } from 'src/app/root-store/tickets-store/ticket-email-settings-store.module';
import { DocumentTypesStoreModule } from './doc-admin-store/doc-admin.module';
import { CredentialingStoreModule } from 'src/app/root-store/credentialing/credentialing-store.module';
import { ComplianceStoreModule } from 'src/app/root-store/compliance/compliance-store.module';
import { PerdiemStoreModule } from './perdiem-store/perdiem-store.module';
import { RecruitingJobsStoreModule } from 'src/app/root-store/recruiting-jobs/recruiting-jobs-store.module';
import { LeadQueueStoreModule } from 'src/app/root-store/lead-queue/lead-queue-store.module';
import { AccountManagersStoreModule } from 'src/app/root-store/account-managers-store/account-managers-store.module';
import { DashboardStoreModule } from 'src/app/root-store/dashboard-store/dashboard-store.module';
import { ReportingStoreModule } from 'src/app/root-store/reporting-store/reporting-store.module';
import { WorkforceSolutionsStoreModule } from './workforce-solutions-store/workforce-solutions-store.module';
import { RecruitingStoreModule } from './recruiting-store/recruiting-store.module';
import { MarginCalculatorStoreModule } from './margin-calculator/margin-calculator-store.module';
import { TravelXNewStoreModule } from 'src/app/root-store/travelxnew/travelxnew-store.module';
import { ValidationsStoreModule } from 'src/app/root-store/validations/validations-store.module';
import { NotesStoreModule } from 'src/app/root-store/notes-store/notes-store.module';
import { InAppNotificationsStoreModule } from 'src/app/root-store/in-app-notifications-store/in-app-notifications-store.module';
import { HubConnectionStoreModule } from 'src/app/root-store/hub-connection-store/hub-connection.module';
import { FlyoutStoreModule } from './flyout-store/flyout-store.module';
import { UnsignedUploadDocumentStoreModule } from 'src/app/recruiting/candidates/new-profile/candidate-uploaded-profile-document/store/unsigned-upload-document-store.module';
import { InAppNotificationPreferencesStoreModule } from 'src/app/root-store/in-app-notifications-store/in-app-notification-preferences-store.module';
import { LocumsStoreModule } from './locums-store/locums-store.module';
import { AccountManagersSubmittalsStoreModule } from 'src/app/root-store/account-managers-submittals-store/account-managers-submittals-store.module';
import { CandidateProfileComponentStoreModule } from './candidate-profile-component-store/candidate-profile-component-store.module';
import { AccountManagerDashboardStoreModule } from './account-managers-dashboard-store/account-managers-dashboard-store.module';
import { TimecardStoreModule } from './timecard-store/timecard-store.module';
import { InvoiceStoreModule } from './invoice-store/invoice-store.module';
import { ReverseInvoiceStoreModule } from './reverse-invoice-store/reverse-invoice-store.module';
import { DelegationsStoreModule } from 'src/app/root-store/delegations-store/delegations-store.module';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        EsignStoreModule,
        DocumentTypesStoreModule,
        TicketStoreModule,
        TicketEmailSettingsStoreModule,
        CredentialingStoreModule,
        ComplianceStoreModule,
        MarginCalculatorStoreModule,
        RecruitingStoreModule,
        TravelXNewStoreModule,
        AccountManagersStoreModule,
        AccountManagersSubmittalsStoreModule,
        PerdiemStoreModule,
        RecruitingJobsStoreModule,
        LeadQueueStoreModule,
        ReportingStoreModule,
        DashboardStoreModule,
        WorkforceSolutionsStoreModule,
        ValidationsStoreModule,
        NotesStoreModule,
        InAppNotificationsStoreModule,
        InAppNotificationPreferencesStoreModule,
        HubConnectionStoreModule,
        FlyoutStoreModule,
        UnsignedUploadDocumentStoreModule,
        LocumsStoreModule,
        CandidateProfileComponentStoreModule,
        AccountManagerDashboardStoreModule,
        TimecardStoreModule,
        InvoiceStoreModule,
        ReverseInvoiceStoreModule,
        DelegationsStoreModule
    ]
})
export class RootStoreModule {}
